import React, { useEffect } from 'react'
import './style.css'

import { RouteComponentProps } from 'react-router'
import { useDispatch } from 'react-redux'
import { useLogsActions } from 'core/actions'
import Header from 'components/Header'
import { LogsGrid } from 'components/LogsGrid'
import AutoSizer from 'react-virtualized-auto-sizer'
import { useAppSelector } from '../../core/hooks'
import { getApi } from '../../core/api'
import { AtomInstance } from '../../components/SearchTextInput'
import { SearchDescriptor } from '../../api/extra/model/search-descriptor'

type LogsProps = RouteComponentProps<void>

const Logs = ({ history }: LogsProps) => {
  const {
    api: { syslogApi },
    user,
  } = useAppSelector((state) => ({
    api: getApi(state.auth.user) ?? { syslogApi: null },
    user: state.auth.user,
  }))
  const dispatch = useDispatch()
  const { launchSearch } = useLogsActions(dispatch)

  const redirectToLoginPage = (reason?: string) => {
    console.warn(`Logout because of ${reason || 'unknown reason'}`)
    history.push('/login')
  }

  useEffect(() => {
    if (!syslogApi || !user) {
      redirectToLoginPage('Not logged')
    }
  }, [syslogApi, user])

  return (
    <div className={'normal'} style={{ height: 'calc(100vh - 48px)' }}>
      <Header
        search={(descriptor?: SearchDescriptor, tags?: AtomInstance[]) => {
          if (syslogApi && descriptor) {
            launchSearch({
              api: syslogApi,
              descriptor,
            })
          } else if (syslogApi && tags) {
            const mappedTags = tags.reduce((rules, t, idx, tags) => {
              if (t.atom.headAtom) {
                return [...rules, { tag: t.atom.key, value: '' }]
              } else if (!t.atom.nextAtoms) {
                const r = rules[rules.length - 1]
                const head = rules.slice(0, rules.length - 1)
                return [...head, { ...r, value: r.tag === 'date' ? tags[idx - 1].atom.keyword + t.value : t.value }]
              }
              return rules
            }, [] as { tag: string; value: string }[])
            launchSearch({
              api: syslogApi,
              tags: mappedTags,
            })
          }
        }}
      />

      <AutoSizer>{({ height, width }) => <LogsGrid width={width} height={height} />}</AutoSizer>
    </div>
  )
}
export default Logs
